// @flow

import * as React from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {actionCreators} from "../store/Calculation";
import type {CalculationRequestInfo, CalculationRequestProjectInput} from "../common/RequestTypes";
import RequestDataCreatorInverse from "../common/RequestDataCreatorInverse";
import OptionManager from "../common/OptionManager";
import DefaultValueManager from "../common/DefaultValueManager";
import type {Action, ProjectUiInput} from "../store/Calculation";
import {history} from "../index";
import config from "../common/Config";
import ReactAI from 'react-appinsights';

type Props = {
    history: ?CalculationRequestInfo[],
    historyIsLoading: boolean,
    requestHistory: Function,
    clearCalculationResult: () => Action,
    setCalcParams: (params: ProjectUiInput) => Action,
    projectUiInput: ProjectUiInput,
    allHistoryLoaded: boolean,
};

type State = {
}

class Projects extends React.Component<Props, State> {

    optionManager: OptionManager;
    defaultValueManager: DefaultValueManager;
    stateCreator: RequestDataCreatorInverse;

    constructor(props: Props) {
        super(props);
        this.optionManager = new OptionManager();
        this.defaultValueManager = new DefaultValueManager(this.optionManager);
        this.stateCreator = new RequestDataCreatorInverse(this.optionManager, this.defaultValueManager);
    }

    componentWillMount() {
        // if(this.props.history == null && !this.props.historyIsLoading)
        //     this.props.requestHistory(config.historyMaxCount, config.historyMinVersion, null);
    }

    render() {
        let loadMoreEl = <button type="button" className="btn btn-primary print-hide" onClick={this.fetchOlderCalculations.bind(this)}>Hämta äldre beräkningar</button>;
        if(this.props.allHistoryLoaded && this.props.history && this.props.history.length > 0)
            loadMoreEl = null;
        return (<div className="projects">
            <h1>Projekt</h1>
            <div>
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Tid</th>
                            <th scope="col">Projekt</th>
                            <th scope="col" className="d-none d-sm-table-cell">Etapper</th>
                            <th scope="col" className="d-none d-sm-table-cell">Resultat</th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.props.history && this.props.history.filter(calcInfo => calcInfo.frontendVersion >= config.historyMinVersion).map(calcInfo => <tr key={calcInfo.requestTimeLocal} onClick={ this.loadCalculation.bind(this, calcInfo.requestInput) }>
                            <td>{this.formatTime(calcInfo.requestTimeLocal)}</td>
                            <td>{calcInfo.requestInput.projectName}</td>
                            <td className="d-none d-sm-table-cell">{calcInfo.requestInput.phases.length}</td>
                            <td className="d-none d-sm-table-cell">{ this.round(calcInfo.requestResult.totalResult.perCentLowerTotalNoDig * 100, 0)} %</td>
                        </tr>) }
                    </tbody>
                </table>
                { this.props.historyIsLoading ? <p>Laddar...</p> : loadMoreEl }
            </div>
        </div>);
    };
    
    fetchOlderCalculations() {
        if(this.props.history) {
            let historyFromServer = this.props.history.filter(item => item.requestTimeUtc);
            if(historyFromServer.length > 0) {
                let oldestFromServer = historyFromServer[historyFromServer.length - 1];
                this.props.requestHistory(config.historyMaxCount, config.historyMinVersion, oldestFromServer.requestTimeUtc);
            }
        }
    }
    
    loadCalculation(input: CalculationRequestProjectInput) {
        let newState = this.stateCreator.createProjectState(input);
        newState = this.upgradeStateIfNecessary(newState);
        this.props.clearCalculationResult();
        this.props.setCalcParams(newState);
        history.push("/calculation");
        // $FlowFixMe
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    
    upgradeStateIfNecessary(state: ProjectUiInput) {
        let currentVersion = this.props.projectUiInput.version;
        let newVersion = state.version;
        
        if(newVersion !== currentVersion) {
            console.log(`Upgrading state version ${newVersion} to ${currentVersion}`);

            // TODO: Upgrade when necessary...
            
            // Finally set new version 
            state = {...state, version: currentVersion};
        }
        
        return state;
    }
    
    formatTime(localTime: string) {
        return localTime.substring(0, localTime.lastIndexOf(":"));        
    }

    round(value: number, numDecimals: number): string {
        if(value === 0) {
            return "-";
        }
        else {
            let rounded = parseFloat(value.toFixed(numDecimals));
            if(this.detectIE() === false)
                return rounded.toLocaleString("se-SV"); // Not OK in IE 10 and 11
            else
                return rounded.toString().replace(".", ",");
        }
    }

    detectIE() {
        let ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        let msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        let trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            let rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        let edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    }


}

export default ReactAI.withTracking(connect(
    state => state.calculation,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Projects));




// WEBPACK FOOTER //
// ./src/components/Projects.js